import {
  fetchCreateMessageForOffer,
  ICreateMessageForOfferRequest,
  ICreateMessageForOfferResponse,
  ICreateMessageForOfferResponseError,
} from '../../repositories/demand/v2/create-message-for-offer';
import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import {
  trackOpenSmsPopup,
  trackPhoneVerificationSuccess,
  trackSendFormSuccess,
  trackVerificationPhoneError,
} from '../../components/demand/utils/tracking';
import {
  EVerifyPhoneError,
  verifyPhoneSecondsToRetrySmsChangedAction,
  verifyPhoneSetErrorMessageAction,
} from '@cian/sms-validation-widget';
import {
  closeDemandSmsVerificationModal,
  demandRequestSendError,
  demandRequestSendStart,
  demandRequestSendSuccess,
  openDemandSmsVerificationModal,
  openDemandSuccessModal,
} from './requestDemand';

export const sendDemandRequest = (parameters: ICreateMessageForOfferRequest): ThunkAction<void, IState, IContext> => {
  return async (dispatch, getState, extra) => {
    const { httpApi } = extra;
    const { requestDemand } = getState();

    if (!requestDemand.isFetching) {
      dispatch(demandRequestSendStart(parameters));

      try {
        const { statusCode, response } = await fetchCreateMessageForOffer({ httpApi, parameters });

        if (statusCode !== 200) {
          return dispatch(demandRequestSendError((response as ICreateMessageForOfferResponseError).message));
        }

        const responseData = response as ICreateMessageForOfferResponse;
        const isHomeowner = Boolean(parameters.isHomeowner);
        dispatch(demandRequestSendSuccess());

        switch (responseData.status) {
          case 'needPhoneConfirm':
            trackOpenSmsPopup(isHomeowner);
            dispatch(verifyPhoneSecondsToRetrySmsChangedAction(responseData.confirmTimeout as number));
            dispatch(openDemandSmsVerificationModal());

            return;

          case 'codeError':
            trackVerificationPhoneError(isHomeowner);

            return dispatch(verifyPhoneSetErrorMessageAction(EVerifyPhoneError.NOT_CORRECT));

          default:
            if (parameters.confirmationCode) {
              trackPhoneVerificationSuccess(isHomeowner);
            }

            trackSendFormSuccess(isHomeowner);
            dispatch(closeDemandSmsVerificationModal());

            return dispatch(openDemandSuccessModal());
        }
      } catch (exc) {
        return dispatch(demandRequestSendError(exc.message));
      }
    }

    return Promise.resolve();
  };
};
